<template>
  <div class="header relative">
    <nav class="navbar navbar-default">
      <div class="container-fluid">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <a class="navbar-brand" @click="logo()"
            ><i class="iconfont3 icon-bn-logo font20"></i
          ></a>
          <button
            type="button"
            class="navbar-toggle visible-xs"
            data-toggle="modal"
            data-target="#right-menu"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" v-if="!user">
          <ul class="nav navbar-nav">
            <li><a href="https://blacknova.co/any">ANY </a></li>
            <li><a href="https://blacknova.co/alba">ALBA</a></li>
            <li><a href="https://blacknova.co/aria">ARIA</a></li>
          </ul>

          <button
            type="button"
            class="navbar-toggle pull-right mr-15"
            data-toggle="modal"
            data-target="#right-menu"
          >
            <i class="iconfont3 icon-menu font20"></i>
          </button>
          <ul class="nav navbar-nav navbar-right">
            <li><a href="https://blacknova.co/register">Get Black Nova </a></li>
            <li><a href="#/collection">Create your keypad </a></li>
            <li class="ml">
              <a v-if="user" href="#"
                >{{ user.first_name }} {{ user.last_name }}</a
              >
            </li>
          </ul>
        </div>
        <!-- /.navbar-collapse -->
        <div class="collapse navbar-collapse" v-else>
          <ul class="nav navbar-nav">
            <li><a href="#/dashboard">Dashboard</a></li>
            <li><a href="#/support">Support</a></li>
            <li><a href="#/news">News</a></li>
          </ul>

          <button
            type="button"
            class="navbar-toggle pull-right mr-15"
            data-toggle="modal"
            data-target="#right-menu"
          >
            <i class="iconfont3 icon-menu font20"></i>
          </button>
          <ul class="nav navbar-nav navbar-right">
            <li><a href="#/collection">Artwork Tool</a></li>
            <li class="ml">
              <a href="#">{{ user.title }} {{ user.last_name }}</a>
            </li>
          </ul>
        </div>
        <!-- /.navbar-collapse -->
      </div>
      <!-- /.container-fluid -->
    </nav>

    <!-- Right Bar Menu -->
    <div
      class="modal fade"
      id="right-menu"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <p class="text-right">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i class="iconfont3 icon-close font20"></i>
            </button>
          </p>
          <div class="prl70 pt100 text-center">
            <ul class="list-unstyled menu font20">
              <li><a href="https://blacknova.co/download/">DOWNLOAD</a></li>
              <li><a href="https://blacknova.co/contact/">CONTACT</a></li>
              <li><a href="https://blacknova.co/category/news">NEWS</a></li>
              <li><a href="https://blacknova.co/about/">ABOUT</a></li>

              <div v-if="user">
                <hr />
                <li><a :href="'#/account/' + user._id">ACCOUNT SETTINGS</a></li>
                <li><a @click="logout()">LOG OUT</a></li>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Header",
  data() {
    return {};
  },
  methods: {
    logo() {
      let path = this.$route.path;
      if (
        path == "/collection/config" ||
        path == "/collection/engraving" ||
        path == "/collection/preview" ||
        path == "/collection/complete"
      ) {
        this.$confirm("Are you sure you want to leave?", "Warning", {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning",
        }).then(() => {
          this.$router.push({ path: "/collection" });
        });
      } else if (path == "/login") {
        this.$router.push({ path: "/login" });
      } else {
        window.location.href = "https://blacknova.co/";
      }
    },
    logout() {
      this.$store.state.user = null;
      this.$cookies.remove("remember_me_token");
      axios.get("/logout").then(() => {
        this.$router.push({ path: "/login" });
      });
    },
  },
  computed: {
    user: function () {
      return this.$store.state.user;
    },
  },
};
</script>

<style scoped>
</style>
